var _class, _descriptor, _lookupCountryAddressDataCache;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldGet(e, t) { var r = _classPrivateFieldGet2(t, e); return _classApplyDescriptorGet(e, r); }
function _classPrivateFieldGet2(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { FeCountryAddressDataRequest } from '@square/dashboard-protos/models/squareup/address/service';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import address from '@dashboard/shared-ui/clients/address';
const lookupCountryAddressDataKey = (country, locale = '') => JSON.stringify({
  country,
  locale
});
let AddressFrontend = (_class = (_lookupCountryAddressDataCache = /*#__PURE__*/new WeakMap(), class AddressFrontend extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _classPrivateFieldInitSpec(this, _lookupCountryAddressDataCache, {
      writable: true,
      value: new Map()
    });
  }
  lookupCountryAddressData(countryOrUndefined, locale) {
    const country = countryOrUndefined ?? Country[this.userInfo.countryCode];
    // TODO(steckel): Extract assertions from ui and import in api.
    if (country == null) {
      throw new Error('invariant: country cannot be nullable');
    }
    const key = lookupCountryAddressDataKey(country, locale);
    const cacheResult = _classPrivateFieldGet(this, _lookupCountryAddressDataCache).get(key);
    if (cacheResult != null) {
      return cacheResult;
    }
    const request = FeCountryAddressDataRequest.create({
      country,
      locale
    });
    const response = address.lookupCountryAddressData(request);
    _classPrivateFieldGet(this, _lookupCountryAddressDataCache).set(key, response);
    return response.catch(e => {
      _classPrivateFieldGet(this, _lookupCountryAddressDataCache).delete(key);
      throw e;
    });
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { AddressFrontend as default };